import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { useContext, useEffect, useState } from "react";
import { LangContext } from "../../../Context/LangContext";

import "./Hero.css";
import BtnsApps from "../BtnsApps/BtnsApps";
import { TITLE, baseURL } from "../../../Api/Api";
import  axios  from "axios";

export default function Hero() {
  const langCtx = useContext(LangContext);
  const [title , setTitle] = useState("");
  useEffect(() => {
    axios.get(`${baseURL}/${TITLE}`, {
      headers: {
        "Accept": "application/json",
        "Accept-Language": `${langCtx}`,
      },
    })
    .then((data) => setTitle(data.data.data));
  }, [langCtx]);


  return (
    <div className="hero" id="hero">
      <div className="main-container">
        <Row className="align-items-center">
          <Col lg={6}>
            <div className="text-hero">
              <h1>
                {text.nameHero[langCtx]}
                <h3>
                  Personal <span> Trainer </span>
                </h3>
              </h1>
              <p>{title}</p>
              <BtnsApps />
            </div>
          </Col>

          <Col lg={6}>
            <div className="img-hero">
              <img src="/images/bgheader.png" alt="image_header" />
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
}

const text = {
  nameHero: {
    ar: "مرحبا بك في تطبيق",
    en: "Welcome to application",
  },
  desHero: {
    ar: "تطبيق يقدم خدمات متنوعة للمستخدم و مزودي الخدمة  رياضية .. تعليمية .. حرف و مهارات ",
    en: "An application that provides various services to the user and service providers Sports... educational... crafts and skills",
  },
};
